import { prependPathWithParams } from '@dhl/utils'
import { pushDataToGtm } from '@dhl/third-party'

import { trackTraceLinks } from '~/tracktrace/links'
import { dashboardLinks } from '~/dashboard/links'
import { locatorLinks } from '~/locator/links'
import { piecesLinks } from '~/pieces/links'
import { moreLinks } from '~/more/links'

import { getConfig } from './config'
import { externalPaths, paths } from './paths'

const isAccept = window.location.hostname.includes('accept') || window.location.hostname.includes('localhost')

const externalLinks = {
  pwaLink: () => `/${externalPaths.PWA}`,
  signUpLink: () => `/${externalPaths.ACCOUNT}/sign-up?referrer=portal`,
  signInLink: () => `/${externalPaths.ACCOUNT}/sign-in?referrer=portal`,
  oldTnTLink: (barcode: string, postalCode?: string, querystring?: string) => {
    const { gtm } = getConfig()
    pushDataToGtm(
      {
        event: 'explicit.application.tracktrace.turnOffNewVersion',
        action: 'go to old T&T page',
        loggedInState: 'logged_out',
        eventNonInteraction: false,
      },
      !!gtm.id
    )
    const url = isAccept
      ? 'https://track-and-trace-accept.dhlparcel.nl'
      : 'https://dhlecommerce.nl/nl/consument/volg-je-pakket'
    return [`${url}?tc=${barcode}&pc=${postalCode || ''}`, querystring].join('&')
  },
  rootLink: () => '/',
}

export const links = {
  ...prependPathWithParams(() => paths.DASHBOARD, dashboardLinks),
  ...prependPathWithParams(() => paths.SHIPMENTS, piecesLinks),
  ...prependPathWithParams(() => paths.LOCATOR, locatorLinks),
  ...prependPathWithParams(() => paths.MORE, moreLinks),
  ...prependPathWithParams(() => paths.TRACKTRACE, trackTraceLinks),
  ...prependPathWithParams(() => paths.C2C, {
    c2cLink: () => `/`,
    c2cNewParcelLink: () => `/new-parcel`,
  }),
  ...externalLinks,
}
